//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { date } from "quasar";
import { mapState } from "vuex";

const { formatDate } = date;
let wasSelection = false;

export default {
    name: "AQDateTimePicker",
    props: {
        value: {
            validation(value) {
                return value === null || value.constructor === Date;
            }
        },
        mode: {
            type: String,
            default: "date",
            validation(value) {
                return ["date", "time", "datetime"].includes(value);
            }
        },
        mask: { type: String, default: "DD-MM-YYYY" },
        label: { type: String, default: null },
        hint: { type: String, default: null },
        clearable: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        error: { type: Boolean, default: false },
        manual: { type: Boolean, default: false },
        showToggleHint: {type: Boolean, default: false}
    },
    data() {
        return {
            activeTab: null,
            showDialog: false,
            proxyValue: null,
            proxyDate: null,
            localValue: null,
            localDate: null,
            isActive: false,
            temporaryDate: null,
            temporaryTime: null,
            isDigital: true,
            isAM: true,
            timeMinutes:"",
            timeHours: "", 
            keyHours: 0,   
            keyMinutes: 100, 
            pickerDate: null,
            labelHours: "- -",
            labelMinutes: "- -",
            timeValue: null,
            dateMonths: {
                days: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                daysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                firstDayOfWeek: 1,
            }
        };
    },
    watch: {
        showDialog(value) {
            if (wasSelection && this.displayTime && !value) {
                wasSelection = false;
                this.showDialog = true;
            }
        },
        value(value) {
            this.updateLocalValues(value);            
            if (this.showDialog) {
                this.showDialog = false;
            }
        }
    },
    computed: {
        ...mapState("components", ["isSmallScreen"]),
        displayDate() {
            return ["date", "datetime"].includes(this.mode);
        },
        displayTime() {
            return ["time", "datetime"].includes(this.mode);
        },
        isTime() {
            return this.activeTab === "time";
        },
        isDate() {
            return this.activeTab === "date";
        },
        checkIfHasTime() {
            return this.isDigital ? (this.timeHours && this.timeMinutes) : !this.temporaryTime;
        },
        checkDisableBtn() {
            return this.displayDate && this.displayTime ? ((this.temporaryDate || this.proxyValue) && this.checkIfHasTime) : this.checkIfHasTime;
        },
        getLabelDateFormat() {
            return this.pickerDate || "- - - - - - - - - -";
        },
        getLabelTimeFormat() {
            return `${this.labelHours} : ${this.labelMinutes} ${this.isAM ? 'AM' : 'PM'}`;            
        }
    },
    methods: {
        updateValues() {            
            this.localValue = this.proxyValue;
            this.localDate = this.proxyDate;
            if (this.showDialog) {
                this.showDialog = false;
            }
            this.$emit("input", this.localDate);
            this.$emit("value", this.localValue)
        },
        clearDate() {       
            if (this.isDigital) {
                this.timeHours = "";
                this.timeMinutes = "";
            }     
            if (this.displayDate && this.displayTime) {
                this.labelHours = "- -";
                this.labelMinutes = "- -";
            }
            this.proxyValue = null;
            this.proxyDate = null;
            this.updateValues();
        },
        onFocus(ev) {            
            const element = ev.target || ev.srcElement;
            this.isActive = true;            
            if (element.nodeName.toLowerCase() !== "button") {
               this.showDialog = true;
            }            
        },
        onBlur(ev) {
            this.isActive = false;
            this.$emit("blur", ev);
        },
        updateDate(date, values) {
            const { day, month, year, hour, minute, second } = values;
            const returnDate = new Date(date);
            const isValue = (value) => value !== null && value !== undefined;

            if (day) { returnDate.setDate(day); }
            if (month) { returnDate.setMonth(month - 1); }
            if (year) { returnDate.setFullYear(year); }
            if (isValue(hour)) { returnDate.setHours(hour); }
            if (isValue(minute)) { returnDate.setMinutes(minute); }
            if (isValue(second)) { returnDate.setSeconds(second); }

            return returnDate;
        },
        beforeDlgShow() {            
            this.activeTab = this.displayDate ? "date" : "time";
            if (this.localDate) {
                this.proxyDate = new Date(this.localDate);
                this.proxyValue = formatDate(this.proxyDate, this.mask);
                const [newMask] = this.mask.split(" ");
                this.pickerDate = formatDate(this.proxyDate, newMask);
                this.setTimeData();
            } else {
                this.proxyDate = null;
                this.proxyValue = null;
                this.pickerDate = null;                
                this.timeHours = "";
                this.timeMinutes = "";
                this.isAM = true;                
                if (this.displayDate && this.displayTime) {
                    this.labelHours = "- -";
                    this.labelMinutes = "- -";
                }
            }
            this.temporaryDate = null;            
        },
        setTimeData() {            
            const timeFormat = (v) => {
                let newValue;
                const addExtra = (e) => (e < 10 ? `0${e}` : e);
                if (v === 0) {
                    newValue = 12;
                    this.isAM = true;
                } else if (v === 12) {                    
                    this.isAM = false;
                    newValue = v;
                } else if (v > 12) {
                    newValue = addExtra(v - 12);
                    this.isAM = false;
                } else {
                    newValue = addExtra(v);
                    this.isAM = true;
                }
                return newValue;
            };
            const hours = this.proxyDate.getHours();
            const minutes = this.proxyDate.getMinutes();
            this.timeHours = timeFormat(hours);
            this.timeMinutes = minutes < 10 ? `0${minutes}` : minutes;
            if (this.displayDate && this.displayTime) {
                    this.labelHours = this.timeHours;
                    this.labelMinutes = this.timeMinutes;
                }
        },
        hoursOnBlur() {            
                const newValue = parseInt(this.timeHours);
                if (!newValue || newValue > 12) {
                    this.timeHours = "";                    
                    this.keyHours++;
                } else if (newValue < 10 && this.timeHours.length < 2) {
                    this.timeHours = `0${this.timeHours}`;                    
                    this.keyHours++;
                }
                this.labelHours = this.timeHours || "- -";                
        },
        minutesOnBlur() {            
            const newValue = parseInt(this.timeMinutes);            
                if (newValue > 59) {
                    this.timeMinutes = "";                    
                    this.keyMinutes++;
                } else {
                    if (newValue < 10 && this.timeMinutes.length < 2) {
                        this.timeMinutes = `0${this.timeMinutes}`;                        
                        this.keyMinutes++;
                    }
                }
                this.labelMinutes = this.timeMinutes || "- -";                                
        },
        onTimePick(_, details) {            
            this.temporaryTime = { details };
        },
        onDatePick(_, reason, details) {
            if (this.displayDate && this.displayTime) {
                const newDate = this.updateDate(this.proxyDate, details);
                const [newMask] = this.mask.split(" ");                
                this.pickerDate = formatDate(newDate, newMask);
            }
            
            this.temporaryDate = {
                reason,
                details
            }
        },
        selectDate() {            
            if (this.temporaryDate) {
                const { reason, details } = this.temporaryDate;
                if (["add-day", "remove-day"].includes(reason)) {
                    this.proxyDate = this.updateDate(this.proxyDate, details);
                    if (reason === "remove-day") {
                        this.proxyValue = formatDate(this.proxyDate, this.mask);
                    }
                    wasSelection = this.displayTime;
                    if (this.displayTime) {
                        this.activeTab = "time";
                    } else if (!this.manual) {
                        this.updateValues();
                    }
                }
                    this.temporaryDate = null;
            } else {
                this.showDialog = false;
            }
        },
        cancelDate() {
            this.temporaryDate = null;
            this.showDialog = false;
        },
        selectTime() {            
            let details;                
            if (this.isDigital) {
                let currentDate = new Date();
                const checkAMHour = (v) => {
                    let newValue;
                    const newHour = parseInt(v);
                    if (this.isAM) {
                        newValue = newHour === 12 ? 0 : newHour;
                    } else {
                        newValue = newHour < 12 ? newHour + 12 : newHour;
                    }                    
                    return newValue;
                }
                const addDetails = (val) => {
                    details = {
                            day : val.getDate(),
                            month : val.getMonth() + 1,
                            year : val.getFullYear()                        
                        }
                }

                if (this.displayDate && this.displayTime) {
                    if (this.temporaryDate) {
                        const {details: { day, month, year }} = this.temporaryDate;
                        details = {
                            day,
                            month,
                            year
                        }
                    } else {
                        addDetails(this.proxyDate);
                    }                    
                } else {
                    addDetails(currentDate);
                }
                details = { ...details, 
                        hour : checkAMHour(this.timeHours),
                        minute : parseInt(this.timeMinutes), 
                        second : null
                    }
            } else {
                [{ details }] = this.temporaryTime;
            }
            
            this.proxyDate = this.updateDate(this.proxyDate, details);
            this.proxyValue = formatDate(this.proxyDate, this.mask);
            if (!this.manual) {
                this.updateValues();
            }
            this.temporaryTime = null;
        },
        cancelTime() {
            this.temporaryDate = null;
            this.temporaryTime = null;
            this.showDialog = false;
        },
        selectPickerData() {
            this.selectDate();
            this.selectTime();
        },
        timeMounted() {            
            const { qTime } = this.$refs;
            const newSetMinute = function (minute) {
                const { innerModel } = this;
                innerModel.minute = minute;
                innerModel.second = null;
            };

            const newGoToNextView = function () {
                if (this.view === 'Hour') {
                    this.view = 'Minute'
                } else if (this.view === 'Minute') {
                    if (this.withSeconds) {
                        this.view = 'Second';
                    } else {
                        this.__updateValue({ second: null });
                    }
                }
            };

            qTime.__setMinute = newSetMinute.bind(qTime);
            qTime.__goToNextView = newGoToNextView.bind(qTime);            
        },
        updateLocalValues(value) {
            if (value) {
                this.localDate = new Date(value);
                this.localValue = formatDate(this.localDate, this.mask);
            } else {
                this.localDate = null;
                this.localValue = null
            }
        },
        toggleShow() {
            this.$emit("toggleShow");
        },
        switchToAnalog() {   
            // The “Analog” view for the “time selector” functionality 
            // will be moved to “backlog”, will be dropped for 
            // now -- reason: legacy functionality, cumbersome to use.         
            const checkAMHour = (v) => {
                    let newValue;
                    const newHour = parseInt(v);
                    if (this.isAM) {
                        newValue = newHour === 12 ? "00" : newHour;
                    } else {
                        newValue = newHour < 12 ? newHour + 12 : newHour;
                    }                    
                    return newValue;
                }
            if (this.timeHours && this.timeMinutes) {
                this.timeValue = `${checkAMHour(this.timeHours)}:${this.timeMinutes}`;
            } else {
                this.timeValue = null;
            }
            this.isDigital = false;            
        },
        switchToDigital() {
            // The “Analog” view for the “time selector” functionality 
            // will be moved to “backlog”, will be dropped for 
            // now -- reason: legacy functionality, cumbersome to use.
        },
        openPicker() {
            if (!this.showDialog) {
                this.showDialog = true;
            }
        },
    },
    created() {        
        this.updateLocalValues(this.value);
        this.activeTab = this.displayDate ? "date" : "time";
    }
};
